import React from 'react';
import { useCookieConsent } from '../contexts/CookieContext';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { setShowBanner } = useCookieConsent();

  return (
    <footer className="bg-night text-white">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-medium mb-4">Kontakt</h3>
            <address className="not-italic text-gray-300">
              <p>Flugsportverein Otto Lilienthal Bad Langensalza e.V.</p>
              <p className="mt-2">Thamsbrücker Landstraße 28</p>
              <p>99947 Bad Langensalza</p>
              <p className="mt-2">
                <a href="tel:+4936038958503" className="text-gray-300 hover:text-white">
                  +49 3603 895 8503
                </a>
              </p>
              <p>
                <a href="mailto:info@flugsportverein.eu" className="text-gray-300 hover:text-white">
                  info@flugsportverein.eu
                </a>
              </p>
            </address>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-4">Flugplatz</h3>
            <p className="text-gray-300">EDEB</p>
            <p className="text-gray-300">E 10° 37.30' / N 051° 07.75'</p>
            <p className="text-gray-300">Frequenz: 125,365 kHz</p>
            <div className="mt-3">
              <a href="/flugplatzinfo" className="text-primary-sky hover:text-sky-300 text-sm">
                → Detaillierte Informationen für UL Piloten
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-4">Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/impressum" className="text-gray-300 hover:text-white inline-flex items-center">
                  Impressum
                </a>
              </li>
              <li>
                <a href="/datenschutz" className="text-gray-300 hover:text-white inline-flex items-center">
                  Datenschutzerklärung
                </a>
              </li>
              <li>
                <button 
                  onClick={() => setShowBanner(true)}
                  className="text-gray-300 hover:text-white inline-flex items-center text-left"
                >
                  Cookie-Einstellungen
                </button>
              </li>
              <li>
                <a 
                  href="https://www.instagram.com/flugsportverein_offiziell/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white inline-flex items-center"
                >
                  <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                    <path
                      fillRule="evenodd"
                      d="M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 0 1-1.153 1.772 4.915 4.915 0 0 1-1.772 1.153c-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 0 1-1.772-1.153 4.904 4.904 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 0 1 1.153-1.772A4.897 4.897 0 0 1 5.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2zm0 1.802c-2.67 0-2.986.01-4.04.058-.976.045-1.505.207-1.858.344-.466.182-.8.398-1.15.748-.35.35-.566.684-.748 1.15-.137.353-.3.882-.344 1.857-.048 1.055-.058 1.37-.058 4.04 0 2.67.01 2.987.058 4.04.045.977.207 1.505.344 1.858.182.466.398.8.748 1.15.35.35.684.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.04.058 2.67 0 2.987-.01 4.04-.058.977-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.684.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.04 0-2.67-.01-2.986-.058-4.04-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 0 0-.748-1.15 3.098 3.098 0 0 0-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.055-.048-1.37-.058-4.04-.058zm0 3.063a5.136 5.136 0 1 1 0 10.27 5.136 5.136 0 0 1 0-10.27zm0 8.468a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666zm6.538-8.671a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Instagram
                </a>
              </li>
              <li>
                <a 
                  href="https://www.facebook.com/flugsportverein.bad.langensalza" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white inline-flex items-center"
                >
                  <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                  Facebook
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-4">Downloads</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="/downloads/Gebührenordnung Sonderlandeplatz Bad Langensalza EDEB.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white inline-flex items-center"
                >
                  <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Gebührenordnung EDEB
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between">
          <p className="text-gray-400">
            &copy; {currentYear} Flugsportverein Otto Lilienthal Bad Langensalza e.V. Alle Rechte vorbehalten.
          </p>
          <p className="text-gray-400 mt-2 md:mt-0 inline-flex items-center">
            Website entwickelt mit
            <svg className="h-4 w-4 mx-1.5 text-accent" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" />
            </svg>
            <span className="sr-only">Liebe</span>
            von www.leanofy.de
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 